import { render, staticRenderFns } from "./AnketsGraph.vue?vue&type=template&id=628b70a8&scoped=true"
import script from "./AnketsGraph.vue?vue&type=script&lang=js"
export * from "./AnketsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b70a8",
  null
  
)

export default component.exports